export const getters = {
  captchaImageSrc(state) {
    return state.captchaImage.imgsIo;
  },
  ticket(state) {
    return state.captchaImage.ticket;
  }
};
